export default __webpack_public_path__ + "static/media/tours-and-activities.ed39ba90.png";